export function titles() {
	return [
		{ name: "Mr", value: "mr" },
		{ name: "Mrs", value: "mrs" },
		{ name: "Miss", value: "miss" },
		{ name: "Ms", value: "ms" },
		{ name: "Dr", value: "dr" },
		{ name: "Father", value: "father" },
		{ name: "Hon", value: "hon" },
		{ name: "Rev", value: "rev" },
		{ name: "Sir", value: "sir" },
		{ name: "Sr", value: "sr" },
	];
}

export function insuranceType() {
	return [
		{ name: "Motor", value: "m" },
		{ name: "Home", value: "h" },
		{ name: "Travel", value: "t" },
		{ name: "Small Business", value: "s" },
		{ name: "Life", value: "l", check: true },
	];
}

export function percentageItems() {
	return [
		{ name: "25%", value: "25", display: "25%" },
		{ name: "50%", value: "50", display: "50%" },
		{ name: "75%", value: "75", display: "75%" },
		{ name: "100%", value: "100", display: "100%" },
		{ name: "125%", value: "125", display: "125%" },
		{ name: "150%", value: "150", display: "150%" },
	];
}

export const occupationList = [
	{
		name: "Professional occupations requiring university qualifications and registration with a professional body. For example, medical practitioners, chartered accountants, engineers and lawyers.",
		value: "professional",
	},
	{
		name: "White collar occupations with duties requiring nil or less than 10% participation in manual and or physical work. For example, real estate agents, building and construction supervisors and call centre employees.",
		value: "whiteCollar",
	},
	{
		name: "Highly Skilled Occupations that require University or TAFE qualifications and involve manual and/or physical work. For example, registered nurses, auto electricians, ambulance officers and retail employees.",
		value: "highlySkilled",
	},
	{
		name: "Occupations that involve manual and/or physical work and may be subject to increased work place hazards. For example, furniture restorers, locksmiths or farm owners.",
		value: "manualLabour",
	},
	{
		name: "Unemployed persons, homemakers or students. People working less than 20 hours per week.",
		value: "unemployed",
	},
];

export function states() {
	return [
		{ name: "Australian Capital Territory", value: "act" },
		{ name: "New South Wales", value: "nsw" },
		{ name: "Queensland", value: "qld" },
		{ name: "Northern Territory", value: "nt" },
		{ name: "South Australia", value: "sa" },
		{ name: "Tasmania", value: "tas" },
		{ name: "Victoria", value: "vic" },
		{ name: "Western Australia", value: "wa" },
	];
}

export const streetNumberType = [
	{ name: "Lot number", value: "lot" },
	{ name: "Street number", value: "street" },
];

export const streetNameType = [
	{
		name: "Street",
		value: "street",
	},
	{
		name: "Avenue",
		value: "avenue",
	},
	{
		name: "Place",
		value: "place",
	},
	{
		name: "Road",
		value: "road",
	},
	{
		name: "Drive",
		value: "drive",
	},
	{
		name: "Access",
		value: "access",
	},
	{
		name: "Alley",
		value: "alley",
	},
	{
		name: "Alleyway",
		value: "alleyway",
	},
	{
		name: "Amble",
		value: "amble",
	},
	{
		name: "Anchorage",
		value: "anchorage",
	},
	{
		name: "Approach",
		value: "approach",
	},
	{
		name: "Arcade",
		value: "arcade",
	},
	{
		name: "Artery",
		value: "artery",
	},
	{
		name: "Basin",
		value: "basin",
	},
	{
		name: "Beach",
		value: "beach",
	},
	{
		name: "Bridge",
		value: "bridge",
	},
	{
		name: "Broadway",
		value: "broadway",
	},
	{
		name: "Bend",
		value: "bend",
	},
	{
		name: "Block",
		value: "block",
	},
	{
		name: "Brae",
		value: "brae",
	},
	{
		name: "Brace",
		value: "brace",
	},
	{
		name: "Break",
		value: "break",
	},
	{
		name: "Brow",
		value: "brow",
	},
	{
		name: "Boulevard",
		value: "boulevard",
	},
	{
		name: "Bypass",
		value: "bypass",
	},
	{
		name: "Byway",
		value: "byway",
	},
	{
		name: "Causeway",
		value: "causeway",
	},
	{
		name: "Circuit",
		value: "circuit",
	},
	{
		name: "Cul-de-sac",
		value: "cul-de-sac",
	},
	{
		name: "Chase",
		value: "chase",
	},
	{
		name: "Circle",
		value: "circle",
	},
	{
		name: "Close",
		value: "close",
	},
	{
		name: "Colonnade",
		value: "colonnade",
	},
	{
		name: "Circlet",
		value: "circlet",
	},
	{
		name: "Common",
		value: "common",
	},
	{
		name: "Corner",
		value: "corner",
	},
	{
		name: "Centreway",
		value: "centreway",
	},
	{
		name: "Concourse",
		value: "concourse",
	},
	{
		name: "Cove",
		value: "cove",
	},
	{
		name: "Crossway",
		value: "crossway",
	},
	{
		name: "Copse",
		value: "copse",
	},
	{
		name: "Circus",
		value: "circus",
	},
	{
		name: "Crossroad",
		value: "crossroad",
	},
	{
		name: "Crescent",
		value: "crescent",
	},
	{
		name: "Crossing",
		value: "crossing",
	},
	{
		name: "Cross",
		value: "cross",
	},
	{
		name: "Crest",
		value: "crest",
	},
	{
		name: "Corso",
		value: "corso",
	},
	{
		name: "Court",
		value: "court",
	},
	{
		name: "Centre",
		value: "centre",
	},
	{
		name: "Cutting",
		value: "cutting",
	},
	{
		name: "Courtyard",
		value: "courtyard",
	},
	{
		name: "Cruiseway",
		value: "cruiseway",
	},
	{
		name: "Dale",
		value: "dale",
	},
	{
		name: "Dell",
		value: "dell",
	},
	{
		name: "Deviation",
		value: "deviation",
	},
	{
		name: "Dip",
		value: "dip",
	},
	{
		name: "Driveway",
		value: "driveway",
	},
	{
		name: "Distributor",
		value: "distributor",
	},
	{
		name: "Edge",
		value: "edge",
	},
	{
		name: "Elbow",
		value: "elbow",
	},
	{
		name: "End",
		value: "end",
	},
	{
		name: "Entrance",
		value: "entrance",
	},
	{
		name: "Espl",
		value: "espl",
	},
	{
		name: "Estate",
		value: "estate",
	},
	{
		name: "Expressway",
		value: "expressway",
	},
	{
		name: "Extension",
		value: "extension",
	},
	{
		name: "Fairway",
		value: "fairway",
	},
	{
		name: "Firetrail",
		value: "firetrail",
	},
	{
		name: "Flat",
		value: "flat",
	},
	{
		name: "Follow",
		value: "follow",
	},
	{
		name: "Formation",
		value: "formation",
	},
	{
		name: "Front",
		value: "front",
	},
	{
		name: "Frontage",
		value: "frontage",
	},
	{
		name: "Foreshore",
		value: "foreshore",
	},
	{
		name: "Fire track",
		value: "fire track",
	},
	{
		name: "Footway",
		value: "footway",
	},
	{
		name: "Freeway",
		value: "freeway",
	},
	{
		name: "Gap",
		value: "gap",
	},
	{
		name: "Garden",
		value: "garden",
	},
	{
		name: "Gardens",
		value: "gardens",
	},
	{
		name: "Glade",
		value: "glade",
	},
	{
		name: "Glen",
		value: "glen",
	},
	{
		name: "Gully",
		value: "gully",
	},
	{
		name: "Grove",
		value: "grove",
	},
	{
		name: "Grange",
		value: "grange",
	},
	{
		name: "Green",
		value: "green",
	},
	{
		name: "Ground",
		value: "ground",
	},
	{
		name: "Gate",
		value: "gate",
	},
	{
		name: "Gates",
		value: "gates",
	},
	{
		name: "Hill",
		value: "hill",
	},
	{
		name: "Highroad",
		value: "highroad",
	},
	{
		name: "Heights",
		value: "heights",
	},
	{
		name: "Highway",
		value: "highway",
	},
	{
		name: "Interchange",
		value: "interchange",
	},
	{
		name: "Intersection",
		value: "intersection",
	},
	{
		name: "Junction",
		value: "junction",
	},
	{
		name: "Key",
		value: "key",
	},
	{
		name: "Lane",
		value: "lane",
	},
	{
		name: "Landing",
		value: "landing",
	},
	{
		name: "Lees",
		value: "lees",
	},
	{
		name: "Line",
		value: "line",
	},
	{
		name: "Link",
		value: "link",
	},
	{
		name: "Lookout",
		value: "lookout",
	},
	{
		name: "Laneway",
		value: "laneway",
	},
	{
		name: "Loop",
		value: "loop",
	},
	{
		name: "Little",
		value: "little",
	},
	{
		name: "Lower",
		value: "lower",
	},
	{
		name: "Mall",
		value: "mall",
	},
	{
		name: "Mew",
		value: "mew",
	},
	{
		name: "Mews",
		value: "mews",
	},
	{
		name: "Meander",
		value: "meander",
	},
	{
		name: "Mount",
		value: "mount",
	},
	{
		name: "Motorway",
		value: "motorway",
	},
	{
		name: "Nook",
		value: "nook",
	},
	{
		name: "Outlook",
		value: "outlook",
	},
	{
		name: "Park",
		value: "park",
	},
	{
		name: "Part",
		value: "part",
	},
	{
		name: "Pass",
		value: "pass",
	},
	{
		name: "Path",
		value: "path",
	},
	{
		name: "Parade",
		value: "parade",
	},
	{
		name: "Pathway",
		value: "pathway",
	},
	{
		name: "Piazza",
		value: "piazza",
	},
	{
		name: "Parklands",
		value: "parklands",
	},
	{
		name: "Pocket",
		value: "pocket",
	},
	{
		name: "Parkway",
		value: "parkway",
	},
	{
		name: "Plateau",
		value: "plateau",
	},
	{
		name: "Plaza",
		value: "plaza",
	},
	{
		name: "Point",
		value: "point",
	},
	{
		name: "Port",
		value: "port",
	},
	{
		name: "Promenade",
		value: "promenade",
	},
	{
		name: "Passage",
		value: "passage",
	},
	{
		name: "Quadrangle",
		value: "quadrangle",
	},
	{
		name: "Quadrant",
		value: "quadrant",
	},
	{
		name: "Quad",
		value: "quad",
	},
	{
		name: "Quay",
		value: "quay",
	},
	{
		name: "Quays",
		value: "quays",
	},
	{
		name: "Ramp",
		value: "ramp",
	},
	{
		name: "Reach",
		value: "reach",
	},
	{
		name: "Ridge",
		value: "ridge",
	},
	{
		name: "Roads",
		value: "roads",
	},
	{
		name: "Roadside",
		value: "roadside",
	},
	{
		name: "Roadway",
		value: "roadway",
	},
	{
		name: "Reserve",
		value: "reserve",
	},
	{
		name: "Rest",
		value: "rest",
	},
	{
		name: "Ridgeway",
		value: "ridgeway",
	},
	{
		name: "Ride",
		value: "ride",
	},
	{
		name: "Ring",
		value: "ring",
	},
	{
		name: "Rise",
		value: "rise",
	},
	{
		name: "Ramble",
		value: "ramble",
	},
	{
		name: "Round",
		value: "round",
	},
	{
		name: "Ronde",
		value: "ronde",
	},
	{
		name: "Range",
		value: "range",
	},
	{
		name: "Row",
		value: "row",
	},
	{
		name: "Right of way",
		value: "right of way",
	},
	{
		name: "Rosebowl",
		value: "rosebowl",
	},
	{
		name: "Route",
		value: "route",
	},
	{
		name: "Retreat",
		value: "retreat",
	},
	{
		name: "Rotary",
		value: "rotary",
	},
	{
		name: "Rue",
		value: "rue",
	},
	{
		name: "Run",
		value: "run",
	},
	{
		name: "River",
		value: "river",
	},
	{
		name: "Riviera",
		value: "riviera",
	},
	{
		name: "Riverway",
		value: "riverway",
	},
	{
		name: "Subway",
		value: "subway",
	},
	{
		name: "Siding",
		value: "siding",
	},
	{
		name: "State Highway",
		value: "state highway",
	},
	{
		name: "Slope",
		value: "slope",
	},
	{
		name: "Sound",
		value: "sound",
	},
	{
		name: "Spur",
		value: "spur",
	},
	{
		name: "Square",
		value: "square",
	},
	{
		name: "Steps",
		value: "steps",
	},
	{
		name: "Strand",
		value: "strand",
	},
	{
		name: "Strip",
		value: "strip",
	},
	{
		name: "Stairs",
		value: "stairs",
	},
	{
		name: "Service way",
		value: "service way",
	},
	{
		name: "Tarn",
		value: "tarn",
	},
	{
		name: "Terrace",
		value: "terrace",
	},
	{
		name: "Thoroughfare",
		value: "thoroughfare",
	},
	{
		name: "Trunkway",
		value: "trunkway",
	},
	{
		name: "Tollway",
		value: "tollway",
	},
	{
		name: "Top",
		value: "top",
	},
	{
		name: "Tor",
		value: "tor",
	},
	{
		name: "Triangle",
		value: "triangle",
	},
	{
		name: "Track",
		value: "track",
	},
	{
		name: "Trail",
		value: "trail",
	},
	{
		name: "Trailer",
		value: "trailer",
	},
	{
		name: "Turn",
		value: "turn",
	},
	{
		name: "Towers",
		value: "towers",
	},
	{
		name: "Underpass",
		value: "underpass",
	},
	{
		name: "Upper",
		value: "upper",
	},
	{
		name: "Vale",
		value: "vale",
	},
	{
		name: "Viaduct",
		value: "viaduct",
	},
	{
		name: "View",
		value: "view",
	},
	{
		name: "Villas",
		value: "villas",
	},
	{
		name: "Vista",
		value: "vista",
	},
	{
		name: "Wade",
		value: "wade",
	},
	{
		name: "Walk",
		value: "walk",
	},
	{
		name: "Way",
		value: "way",
	},
	{
		name: "Wharf",
		value: "wharf",
	},
	{
		name: "Walkway",
		value: "walkway",
	},
	{
		name: "Wynd",
		value: "wynd",
	},
	{
		name: "Yard",
		value: "yard",
	},
	{
		name: "Highroad",
		value: "highroad",
	},
	{
		name: "Motorway",
		value: "motorway",
	},
	{
		name: "N/A",
		value: "n/a",
	},
	{
		name: "QUAY",
		value: "quay",
	},
];

export const ccProcessingAccountName = [
	{
		name: "Allianz",
		value: "allianz",
	},
];

export const ccProcessingAction = [
	{
		name: "New application",
		value: "newApplication",
	},
	{
		name: "Search",
		value: "search",
	},
];

export const ccSearchPeriod = [
	{
		name: "Quotes last 30 days",
		value: "last30days",
	},
	{
		name: "Quotes beyond 30 days",
		value: "beyond30days",
	},
];
